import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

export const getDatepickerConfig = (): BsDatepickerConfig => {
    return Object.assign(new BsDatepickerConfig(), {
        dateInputFormat: 'DD/MM/YYYY'
    });
}


